// ui/src/pages/calendar/TodaySessionLink.tsx
//
// One row in StaffCalendar's "Today" panel. Resolves today's session for a
// class via GET /sessions?classId=&date= (lazy get-or-create — the same
// mechanism RunSession itself relies on), then links to
// /sessions/:sessionId. The testid is keyed by the resolved sessionId
// (`calendar-session-link-{sessionId}`) per the Task 21 contract — not by
// classId/date, since the deep link target IS the session.
//
// If the fetch errors (e.g. the class isn't actually scheduled today, or
// today is closed) this renders the class as plain text with no link,
// rather than a link to nowhere.
import React from 'react';
import { Link } from 'react-router-dom';
import { useGetSessionForClassDateQuery } from '../../store/api/localApi';

interface TodaySessionLinkProps {
  classId: string;
  className: string;
  startTime: string;
  endTime: string;
  date: string;
  scopedPath: (path: string) => string;
}

const TodaySessionLink: React.FC<TodaySessionLinkProps> = ({
  classId,
  className,
  startTime,
  endTime,
  date,
  scopedPath,
}) => {
  const { data, isError } = useGetSessionForClassDateQuery({ classId, date });
  const sessionId = data?.session.id;

  return (
    <li className="px-4 py-3 flex items-center justify-between text-sm">
      <span className="text-gray-900">
        {className} ({startTime}-{endTime})
      </span>
      {sessionId ? (
        <Link
          to={scopedPath(`/sessions/${sessionId}`)}
          data-testid={`calendar-session-link-${sessionId}`}
          className="text-primary-600 hover:text-primary-800 font-medium"
        >
          Open session
        </Link>
      ) : isError ? (
        <span className="text-gray-400">Not available</span>
      ) : null}
    </li>
  );
};

export default TodaySessionLink;
